import { globalEntitlements } from '../utils/globalEntitlements';

/**
 * List of states where DBA is allowed
 */
export const DBA_ALLOWED_STATES = [
  'CO', // Colorado
  'ID', // Idaho
  'IL', // Illinois
  'IN', // Indiana
  'IA', // Iowa
  'ME', // Maine
  'MI', // Michigan
  'MS', // Mississippi
  'MO', // Missouri
  'MT', // Montana
  'NH', // New Hampshire
  'NJ', // New Jersey
  'NY', // New York
  'OH', // Ohio
  'OK', // Oklahoma
  'OR', // Oregon
  'RI', // Rhode Island
  'SD', // South Dakota
  'TX', // Texas
  'UT' // Utah
];

export const DBA_ENTITY_CONFIG = {
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.dbaEntity.buyBox.bulletPoint1' },
        { title: 'productPage.dbaEntity.buyBox.bulletPoint2' },
        { title: 'productPage.dbaEntity.buyBox.bulletPoint3' }
      ],
      productName: 'productPage.dbaEntity.buyBox.productName',
      interactService: {
        ctaType: 'internalCheckout',
        service: 'dba_entity'
      }
    }],
    headerPicture: {
      src: '/s2/raster/phonecall-workshop-laptop.png',
      alt: 'productPage.dbaEntity.heroPicture.altText'
    },
    headline: 'productPage.dbaEntity.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.dbaEntity.page.subheader'
  },
  benefit: {
    title: 'productPage.dbaEntity.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/callsplitrounded.svg',
        title: 'productPage.dbaEntity.valueProp.propTitle1',
        description: 'productPage.dbaEntity.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/strikethroughsrounded.svg',
        title: 'productPage.dbaEntity.valueProp.propTitle2',
        description: 'productPage.dbaEntity.valueProp.shortCopy2'
      },
      {
        icon: '/s2/material-icons/gppgoodrounded.svg',
        title: 'productPage.dbaEntity.valueProp.propTitle3',
        description: 'productPage.dbaEntity.valueProp.shortCopy3'
      }
    ]
  },
  highlight: {
    icon: '/s2/material-icons/rocketlaunchrounded.svg',
    title: 'productPage.dbaEntity.topFeature.title',
    subheader: 'productPage.dbaEntity.topFeature.subheader',
    image: '/s2/raster/writing-retail-tailor.png',
    alt: 'productPage.dbaEntity.topFeature.altText'
  },
  howItWorks: {
    title: 'productPage.dbaEntity.howItWorks.title',
    items: [
      {
        title: 'productPage.dbaEntity.howItWorks.step1',
        description: 'productPage.dbaEntity.howItWorks.shortDescription1'
      },
      {
        title: 'productPage.dbaEntity.howItWorks.step2',
        description: 'productPage.dbaEntity.howItWorks.shortDescription2'
      },
      {
        title: 'productPage.dbaEntity.howItWorks.step3',
        description: 'productPage.dbaEntity.howItWorks.shortDescription3'
      }
    ],
    image: '/s2/raster/woodshop-tablet-tools.png',
    alt: 'productPage.dbaEntity.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true
  },
  faqs: {
    title: 'productPage.dbaEntity.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.dbaEntity.frequentlyAskedQuestions.faq1',
        answer: 'productPage.dbaEntity.frequentlyAskedQuestions.faqAnswer1'
      },
      {
        question: 'productPage.dbaEntity.frequentlyAskedQuestions.faq2',
        answer: 'productPage.dbaEntity.frequentlyAskedQuestions.faqAnswer2'
      },
      {
        question: 'productPage.dbaEntity.frequentlyAskedQuestions.faq3',
        answer: 'productPage.dbaEntity.frequentlyAskedQuestions.faqAnswer3'
      }
    ]
  },
  assistance: {
    title: 'productPage.dbaEntity.needAssistance.title',
    getInTouch: 'productPage.dbaEntity.needAssistance.getInTouch',
    actions: 'productPage.dbaEntity.needAssistance.actions'
  },
  getBuyButtonConfig: globalEntitlements({ ctaText: 'productPage.dbaEntity.buyBox.buttonLabel' })
    .jurisdictionIn(DBA_ALLOWED_STATES)
    .allowMultiplePurchases()
    .build()
};
